/* Layering guide — base/top layer filtering (port of original `Wq` state logic). */
(function () {
  if (customElements.get('layering-guide')) return;
  var ACTIVE = ['border-foreground', 'bg-foreground', 'text-primary-foreground'];
  var INACTIVE = ['border-border', 'text-muted-foreground', 'hover:border-foreground', 'hover:text-foreground'];

  class LayeringGuide extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.base = null;
      this.top = null;
      var self = this;
      this.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-layer-btn]');
        if (!btn || btn.disabled) return;
        var h = btn.getAttribute('data-handle');
        if (btn.getAttribute('data-layer-btn') === 'base') self.base = self.base === h ? null : h;
        else self.top = self.top === h ? null : h;
        self.render();
      });
      this.render(true);
    }

    matches(a, b) {
      var e = this.base, n = this.top;
      return (!e && !n) ||
        (e && !n && (a === e || b === e)) ||
        (!e && n && (a === n || b === n)) ||
        (e && n && ((a === e && b === n) || (a === n && b === e)));
    }

    render(initial) {
      var self = this;
      this.querySelectorAll('[data-layer-btn]').forEach(function (btn) {
        var layer = btn.getAttribute('data-layer-btn');
        var h = btn.getAttribute('data-handle');
        var on = (layer === 'base' ? self.base : self.top) === h;
        ACTIVE.forEach(function (c) { btn.classList.toggle(c, on); });
        INACTIVE.forEach(function (c) { btn.classList.toggle(c, !on); });
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (layer === 'top') btn.disabled = h === self.base;
      });

      var count = 0;
      this.querySelectorAll('[data-combo]').forEach(function (card) {
        var show = !!self.matches(card.getAttribute('data-a'), card.getAttribute('data-b'));
        var was = !card.hidden;
        card.hidden = !show;
        if (show) {
          count++;
          if (!was && !initial) { card.style.animation = 'none'; void card.offsetWidth; card.style.animation = ''; }
        }
      });

      var empty = this.querySelector('[data-combo-empty]');
      if (empty) empty.hidden = count > 0;
      var c = this.querySelector('[data-combo-count]');
      if (c) c.textContent = count;
      var heading = this.querySelector('[data-combo-heading]');
      if (heading) heading.textContent = (this.base || this.top) ? this.dataset.headingMatching : this.dataset.headingAll;
    }
  }
  customElements.define('layering-guide', LayeringGuide);
})();
